import { queryElement as r } from "./ghl-ui.es1191.js";
function f(e, n) {
  if (e === void 0)
    return !1;
  if (n) {
    const { context: { ids: t } } = n;
    return t.has(e);
  }
  return r(e) !== null;
}
export {
  f as exists
};
